import React, { FC, useState } from 'react';
import { ModalBody, ModalHeader } from 'reactstrap';

import lang from '../../../lib/language';

import BaseModal from '../../BaseModal/BaseModal';
import { Button } from '../../index';

import styles from './ExpiredVerificationModal.module.scss';

type Props = {
  forceNoRender?: boolean;
  noModalDisplay?: boolean;
}
const ExpiredVerificationModal: FC<Props> = (props: Props) => {
  const { noModalDisplay, forceNoRender } = props;
  const [showModal, setShowModal] = useState<boolean>(true);

  if (forceNoRender) {
    return <></>;
  }

  const content: JSX.Element = (
    <p className={styles.text}>{lang.commonOnboardingExpiredVerificationLinkBody()}</p>
  );

  return noModalDisplay ? content : (
    <BaseModal isOpen={showModal}>
      <ModalHeader>{lang.commonOnboardingExpiredVerificationLinkTitle()}</ModalHeader>
      <ModalBody>
        {content}
        <Button
          fullWidth
          className={styles.button}
          onClick={() => setShowModal(false)}
        >
          {lang.commonOkay()}
        </Button>
      </ModalBody>
    </BaseModal>
  );
};

export default ExpiredVerificationModal;
